import RejectApproveRequestDialog from "./rejectApproveRequestDialog.container";

export default RejectApproveRequestDialog;
